
export enum AppState {
  WELCOME,
  QUESTIONNAIRE,
  LOADING,
  RESULT,
  SETTINGS,
  WINE_MENU,
}

// 特徴1件（可変長・編集耐性・AI再生成対応）
export interface Characteristic {
  id: string;              // 安定ID（例: uuid）
  label: string;           // 例: 「柑橘」「ミネラル感」
  detail?: string;         // 補足テキスト（任意）
  weight?: number;         // 重要度(0-1等 任意)
  source: 'ai' | 'user';   // 由来（AI生成/人手）
  locked?: boolean;        // ユーザーが"確定"にしたらtrue（AI更新で上書きしない）
  confidence?: number;     // AI側の確信度(任意)
  createdAt: number;       // ms
  updatedAt: number;       // ms
}

export interface Wine {
  id: number;
  name: string;
  type: '赤' | '白' | 'ロゼ' | 'スパークリング';
  origin: string;
  variety: string;
  price: number;
  taste: 'フルボディ' | 'ミディアムボディ' | 'ライトボディ' | '辛口' | '甘口' | 'やや甘口';
  characteristics: string[];  // 下位互換のため残す（廃止予定）
  characteristicsV2?: Characteristic[];  // 新方式（可変長・編集耐性）
  image: string;
  visible: boolean;
  // グラスワイン機能
  isGlassWine?: boolean;
  glassPrice?: number;
}

export interface UserAnswers {
  color: string;
  taste: string;
  price: string;
  origin: string;
  food: string;
  occasion: string;
}

// AIからのレスポンスの型
export interface AiRecommendation {
  id: number;
  name: string;
  type: string;
  origin: string;
  variety: string;
  price: number;
  reason: string;
}

// 画像データを追加したUI表示用の型
export interface RecommendedWine extends AiRecommendation {
  image: string;
}

export interface ShopProfile {
  name: string;
  logo: string; // Base64 encoded image
}

// For data export/import
export interface AppData {
  shopProfile: ShopProfile;
  wineList: Wine[];
  occasions: string[];
  tastes: string[];
  prices: string[];
  origins: string[];
  paginationSettings?: {
    enabled: boolean;
    mode: 'byGenre' | 'byCount';
    winesPerPage: number;
  };
}